import useDineInFlow from "./useDineInFlow";
import useGoogleReview from "./useGoogleReview";
import useGoogleReviewSuggestedProducts from "./useGoogleReviewSuggestedProducts";
import useManifest from "./useManifest";
import useOpeningStatus from "./useOpeningStatus";
import useOrderingDisabledStatus from "./useOrderingDisabledStatus";
import useProductIdentifiers from "./useProductIdentifiers";
import useTips from "./useTips";

export default {
  useDineInFlow,
  useGoogleReview,
  useGoogleReviewSuggestedProducts,
  useManifest,
  useOpeningStatus,
  useOrderingDisabledStatus,
  useProductIdentifiers,
  useTips,
};
